import timetable from "./instruments/timetable";
import exchange from "./instruments/exchange";
import settings from "./instruments/settings";
import reports from "./instruments/reports";
import forecast from "./instruments/forecast";
import staff from "./instruments/staff";
import { EMPLOYEE_EMPLOYMENT_STATUSES, NETWORK_EMPLOYMENT_STATUSES, INTERNAL_EMPLOYMENT_STATUSES, OUTSOURCE_EMPLOYMENT_STATUSES } from '@/config/time-table';
export default {
  locales: {
    selectTitle: 'Выберите язык интерфейса'
  },
  modal: {
    ok: 'Ок',
    cancel: 'Отмена',
    delete: 'Удалить',
    copy: 'Копировать',
    filter: 'Применить фильтр'
  },
  mainTerms: {
    hour: 'ч',
    preliminaryCostPerHourMoney: 'р/час',
    preliminaryCostPerHour: 'Предварительная стоимость работ аутсорс',
    tabelCode: 'табельный номер',
    TabelCode: 'Табельный номер',
    tabCode: 'таб. номер',
    outsource: 'аутсорс',
    department: '<%shop_singular_I_Upper%>',
    selected: 'Выбрано',
    save: 'Сохранить',
    download: 'Скачать',
    noResults: 'нет результатов',
    position: 'должность',
    workType: 'тип работы',
    dayType: 'тип дня',
    tabelType: 'тип табеля',
    error: 'Ошибка',
    lastName: 'Фамилия',
    firstName: 'Имя',
    middleName: 'Отчество',
    worker: 'Сотрудник',
    day: 'день',
    date: 'дата',
    minutes: 'мин',
    sex: [{
      label: 'Женский',
      value: 'F'
    }, {
      label: 'Мужской',
      value: 'M'
    }],
    sexLabel: 'Пол',
    phone: 'Номер телефона',
    yesNo: {
      yes: 'Да',
      no: 'Нет'
    },
    confirmationTitle: 'Подтверждение',
    selectEmployee: 'Выбор сотрудника',
    // status: {
    //   'W': 'Рабочий день',
    //   'H': 'Выходной',
    //   'V': 'Отпуск',
    //   'TV': 'Отпуск за свой счёт',
    //   'Q': 'Учеба',
    //   'A': 'Неявка',
    //   'M': 'Декрет',
    //   'S': 'Больничный',
    //   'T': 'Командировка',
    //   'O': 'Другое',
    //   'E': 'Удаление',
    //   'D': 'Нет данных'
    // },
    // statusShort: {
    //   'W': 'Р/Д',
    //   'H': 'Вых',
    //   'V': 'Отп',
    //   'TV': 'ОЗСС',
    //   'Q': 'Уч',
    //   'A': 'Отс',
    //   'M': 'Дек',
    //   'S': 'Бол',
    //   'T': 'Ком',
    //   'O': 'Др',
    //   'E': 'УД',
    //   'D': 'НД'
    // },
    from: 'с',
    to: 'по',
    noData: 'Нет данных',
    plan: 'План',
    fact: 'Факт',
    clear: 'Очистить',
    of: 'из',
    details: 'Детали',
    apply: 'Применить',
    delete: 'Удалить',
    add: 'Добавить',
    rus: 'рус',
    eng: 'eng',
    resetButton: 'Сбросить',
    allWorkTypes: 'Все типы работ',
    additionalShifts: 'Открытые смены',
    info: 'Общая информация',
    login: 'Логин',
    security: 'Безопасность',
    changePassword: 'Изменение пароля пользователя',
    confirmationPasswordInput: 'пароль для подтверждения',
    confirmationPasswordlabel: 'Введите свой пароль для подтверждения',
    userPasswordInput: 'новый пароль сотрудника',
    userPasswordLabel: 'Введите новый пароль сотрудника',
    outsourcingCompany: 'Аутсорс компания',
    outsourcingCompanies: 'Аутсорс компании',
    nothingFound: 'Ничего не найдено',
    biometric: 'Биометрия',
    deleteBiometric: 'Удалить биометрию',
    addBiometric: 'Добавить биометрию',
    name: 'Название',
    code: 'Код',
    depNotSelected: '<%shop_singular_I_Upper%> не выбран',
    savedSuccessfully: 'Успешно сохранено',
    failedToSave: 'Ошибка. Данные не были сохранены.'
  },
  layouts: {
    login: {
      loginLabel: 'Логин',
      passwordLabel: 'Пароль',
      submitLabel: 'Войти',
      badLogin: 'Слишком короткий логин',
      badPassword: 'Слишком короткий пароль',
      topLabel1: 'Вместе делать компанию лучше',
      authFailed: 'Неверный логин или пароль',
      resetPassword: 'Сбросить пароль',
      backToAuth: 'Вернуться на экран авторизации',
      forgotPassword: 'Забыли пароль'
    },
    main: {
      exitMenuItem: {
        title: 'Выход',
        icon: 'exit_to_app'
      },
      profile: {
        changePassword: 'Безопасность',
        exit: 'Выйти из аккаунта',
        reference: 'Справка',
        version: 'Версия',
        buildDate: 'Дата билда',
        noAppInfo: 'Нет информации о приложении'
      }
    }
  },
  menu: [
  /*
  {
    path: '/schedule',
    title: 'Мой график'
  },
  */
  {
    path: '/forecast',
    allowedTab: 'load_forecast',
    title: 'Прогноз потребности',
    metrikaIdReach: 'follow_to_header_forecast'
  }, {
    path: '/timetable',
    allowedTab: 'schedule',
    title: 'Расписание',
    metrikaIdReach: 'follow_to_header_timetable'
  }, {
    path: '/staff',
    allowedTab: 'employees',
    title: 'Сотрудники',
    metrikaIdReach: 'follow_to_header_staff'
  }, {
    path: '/exchange',
    allowedTab: 'shift_exchange',
    title: 'Биржа смен',
    metrikaIdReach: 'follow_to_header_exchange'
  }, {
    path: '/reports',
    allowedTab: 'analytics',
    title: 'Аналитика',
    metrikaIdReach: 'follow_to_header_reports'
  }, {
    allowedTab: 'settings',
    path: '/settings',
    title: 'Настройки'
  }],
  instruments: {
    staticInstruments: {
      dateRange: {
        from: 'с',
        to: 'по'
      },
      departmentLabel: '<%shop_singular_I_Upper%>'
    },
    confirmationGraph: [{
      value: 'acceptPlanned',
      label: 'плановый'
    }, {
      value: 'acceptFactual',
      label: 'фактический'
    }],
    timetable: timetable,
    exchange: exchange,
    staff: staff,
    forecast: forecast,
    schedule: [],
    reports: reports,
    settings: settings
  },
  pages: {
    timetable: {
      dayCellSaved: 'Данные рабочего дня успешно изменены',
      dailyStatsTypes: [{
        label: 'Покрытие',
        value: 'covering'
      }, {
        label: 'Простой',
        value: 'deadtime'
      }, {
        label: 'Рабочих часов по нагрузке',
        value: 'predict_hours'
      }, {
        label: 'Часы без учета открытых вакансий (без учета перерывов)',
        value: 'graph_hours'
      }, {
        label: 'Часы с учетом открытых вакансий (без учета перерывов)',
        value: 'graph_hours_with_open_vacancies'
      }, {
        label: 'Часы с учетом перерыров (без учета открытых вакансий)',
        value: 'work_hours'
      }, {
        label: 'Количество работающих сотрудников (без учета открытых вакансий)',
        value: 'work_days'
      }, {
        label: 'Товарооборот (выручка)',
        value: 'income'
      }, {
        label: 'Производительность (товарооборот / часы с учетом перерывов)',
        value: 'perfomance'
      }
      /*
      { label: 'Смен всего', value: 'shop_shifts' },
      { label: 'Рабочих часов', value: 'shop_paid_hours' },
      { label: 'Открытых смен', value: 'vacancies_shifts' },
      { label: 'Работников из других <%shop_plural_R%>', value: 'outsource_shifts' },
      { label: 'ФОТ', value: 'shop_fot' }
      */
      ],
      byWorkTypes: 'по типам работ',
      byOperationTypes: 'по типам операций',
      workerSortTypes: [{
        label: 'Должность',
        type: 'position'
      }, {
        label: 'ФИО А-Я',
        type: 'fullname-0-1'
      }, {
        label: 'Количество рабочих дней',
        type: 'workingDaysAmount'
      }, {
        label: 'Количество выходных',
        type: 'holidaysAmount'
      }],
      statsLeft: {
        top: [{
          label: 'Рабочих дней в текущем <%shop_singular_P%>',
          value: 'work_days_selected_shop'
        }, {
          label: 'Рабочих дней в других <%shop_plural_P%>',
          value: 'work_days_other_shops'
        }, {
          label: 'Рабочих дней во всех <%shop_plural_P%>',
          value: 'work_days_total'
        }, {
          label: 'Рабочих часов в других <%shop_plural_P%>',
          value: 'work_hours_other_shops'
        }, {
          label: 'Рабочих часов в текущем <%shop_singular_P%>',
          value: 'work_hours_selected_shop'
        }, {
          label: 'Рабочих часов во всех <%shop_plural_P%>',
          value: 'work_hours_total'
        }, {
          label: 'Рабочих часов во всех <%shop_plural_P%> (осн. смены)',
          value: 'work_hours_all_shops_main'
        }, {
          label: 'Рабочих часов во всех <%shop_plural_P%> (доп. смены)',
          value: 'work_hours_all_shops_additional'
        }, {
          label: 'Рабочих часов за учетный период',
          value: 'work_hours_acc_period'
        }, {
          label: 'Норма часов на текущий месяц (рекомендуемая)',
          value: 'sawh_hours_curr_month'
        }, {
          label: 'Норма часов на текущий месяц (рек-я, без уменьшения)',
          value: 'sawh_hours_curr_month_without_reduce_norm'
        }, {
          label: 'Норма часов на текущий месяц (произв. кал.)',
          value: 'norm_hours_curr_month'
        }, {
          label: 'Норма часов на конец текущего месяца (произв. кал.)',
          value: 'norm_hours_curr_month_end'
        }, {
          label: 'Норма часов на учетный период (произв. кал.)',
          value: 'norm_hours_acc_period'
        }, {
          label: 'Переработки за текущий месяц (произв. кал.)',
          value: 'overtime_curr_month'
        }, {
          label: 'Переработки на конец текущего месяца (произв. кал.)',
          value: 'overtime_curr_month_end'
        }, {
          label: 'Переработки за прошлые месяцы (произв. кал.)',
          value: 'overtime_prev_months'
        }, {
          label: 'Переработки за учетный период (произв. кал.)',
          value: 'overtime_acc_period'
        } // { label: 'Рабочий день', value: 'day_type_W' },
        // { label: 'Выходной', value: 'day_type_H' },
        // { label: 'Отпуск', value: 'day_type_V' },
        // { label: 'Отпуск за свой счет', value: 'day_type_TV' },
        // { label: 'Учёба', value: 'day_type_Q' },
        // { label: 'Декрет', value: 'day_type_М' },
        // { label: 'Больничный', value: 'day_type_S' },
        // { label: 'Командировка', value: 'day_type_T' },
        // { label: 'Неявка', value: 'day_type_A' },
        // { label: 'Другое', value: 'day_type_O' }
        ]
      },
      timesheetStats: [{
        label: 'Все часы фактический табель',
        value: 'fact_total_all_hours_sum'
      }, {
        label: 'Рабочие часы фактический табель',
        value: 'fact_total_work_hours_sum'
      }, {
        label: 'Рабочие часы основной табель (все)',
        value: 'main_total_hours_sum'
      }, {
        label: 'Рабочие часы основной табель (ночные)',
        value: 'main_night_hours_sum'
      }, {
        label: 'Рабочие часы дополнительный табель',
        value: 'additional_hours_sum'
      }, {
        label: 'Рекомендуемая норма часов',
        value: 'sawh_hours'
      }, {
        label: 'Рекомендуемая норма часов (без уменьшения)',
        value: 'sawh_hours_without_reduce'
      }, {
        label: 'Норма часов по произв. календарю',
        value: 'norm_hours'
      }],
      workerDayLabelByArg: {
        'PLAN_APPR': 'план. подтв.',
        'PLAN_UNAPPR': 'план. редакт.',
        'FACT_APPR': 'факт. подтв.',
        'FACT_UNAPPR': 'факт. редакт.'
      },
      autoSchedulingModal: {
        title: 'Составление графика',
        period: 'Период составления',
        changesSettings: [{
          label: 'Без изменения существующих смен',
          value: false
        }, {
          label: 'С изменением существующих смен',
          value: true
        }
        /* { label: 'С изменением существующих смен, кроме заказных', value: 3 } */
        ],
        useNotApproved: 'Использовать неподтверждённую версию',
        deleteManualChanges: 'Удалить ручные изменения',
        deleteNotApprovedTimetable: 'Удалить неподтверждённый график',
        deleteTimetableOk: 'Запрос на удаление расписания отправлен успешно',
        deleteTimetableError: 'Произошла ошибка при отправке запроса на удаление расписания',
        autoschedulingStartError: 'Произошла ошибка при отправке запроса на автосоставление расписания',
        autoschedulingStartOk: 'Автосоставление успешно запущено',
        intendFor: 'составить для',
        ok: 'Составить',
        status: {
          'P': 'График составляется'
        },
        searchWorkers: 'Поиск'
      },
      fullWorkerDayEditorModal: {
        title: 'Управление рабочим днём',
        titleVacancy: 'Управление вакансией',
        titleVacancyNew: 'Создание новой вакансии',
        timeBegin: 'время начала',
        timeEnd: 'время конца',
        comment: 'комментарий',
        ok: 'Сохранить изменения',
        removeShift: 'Удалить смену',
        deleteModal: {
          question: 'Вы действительно хотите удалить вакансию?',
          answerPositive: 'Вакансия удалена успешно',
          answerNegative: 'Не удалось удалить вакансию'
        },
        workerEmploymentStatus: [{
          label: 'Сотрудник',
          value: EMPLOYEE_EMPLOYMENT_STATUSES
        }, {
          label: 'Сотрудник моей сети',
          value: NETWORK_EMPLOYMENT_STATUSES
        }, {
          label: 'Внутренняя биржа',
          value: INTERNAL_EMPLOYMENT_STATUSES
        }, {
          label: 'Аутсорс',
          value: OUTSOURCE_EMPLOYMENT_STATUSES
        }],
        selectCategory: 'Выберите категорию',
        selectEmployee: 'Выберите сотрудника',
        selectOutsourcing: 'Выберите аутсорс компанию',
        enterTheDate: 'введите дату',
        enterTheData: 'введите фамилию...',
        staff: 'Сотрудники',
        addWorkType: 'Добавить вид работ',
        workType: 'вид работ',
        shareWorkTime: 'Доля раб. времени',
        costOfWorks: 'Стоимость работ',
        createVacancyFewDay: 'Создать вакансию на несколько дней',
        createFewDay: 'Создать на несколько дней',
        selectDaysOfWeek: 'Выбрать дни недели',
        dayOfWeek: 'дни недели',
        dayOfWeekError: 'Выберите день недели',
        workerDayWeek: [{
          label: 'Пн',
          value: '0'
        }, {
          label: 'Вт',
          value: '1'
        }, {
          label: 'Ср',
          value: '2'
        }, {
          label: 'Чт',
          value: '3'
        }, {
          label: 'Пт',
          value: '4'
        }, {
          label: 'Сб',
          value: '5'
        }, {
          label: 'Вс',
          value: '6'
        }],
        workHoursQty: 'количество часов',
        additionShiftShort: 'Доп',
        additionShift: 'Дополнительная смена',
        rules: {
          number: 'Введите число',
          required: 'Поле обязательно',
          positive: 'Должно быть положительное число',
          less24hours: 'Не должно превышать 24 ч'
        }
      },
      acceptPlanOrFactModal: {
        ok: 'Подтвердить',
        approveOpenVacs: 'Подтвердить открытые смены',
        planTitle: 'Подтверждение планового графика',
        factTitle: 'Подтверждение фактического графика',
        requestTitle: 'Отправить запрос на подтверждение графика',
        planError: 'При подтверждении планового графика произошла ошибка',
        factError: 'При подтверждении фактического графика произошла ошибка',
        planAccepted: 'Плановый график успешно подтверждён',
        factAccepted: 'Фактический график успешно подтверждён',
        requestAccepted: 'Запрос на подтверждение графика прошел успешно',
        dateError: 'Дата конца периода не может быть раньше даты начала',
        requestError: 'При запрос на подтверждение графика произошла ошибка',
        request: 'Отправить запрос',
        comment: 'Комментарии',
        graphics: 'Выбрать вид графика'
      },
      uploadScheduleModal: {
        scheduleTitle: 'Загрузка графика',
        uploadSuccess: 'Данные загружены успешно',
        downloadTemplate: 'Скачать шаблон',
        downloadDescription: 'Скачать описание',
        fileLargeError: 'Данный файл слишком большой',
        uploadErrorWrongData: 'Неверные данные в загруженном файле',
        selectPlanDays: 'План',
        downloadExampleFileTitle: 'Скачать шаблон',
        selectFactDays: 'Факт'
      },
      downloadModal: {
        scheduleTitle: 'Скачать "График смен"',
        tabletTitle: 'Скачать "Табель"',
        needTitle: 'Скачать "Потребность в сотрудниках"',
        consolidatedTitle: 'Скачать "Консолидированный отчет об отработанном времени"',
        tickTitle: 'Скачать "Отчёт по отметкам сотрудников"',
        scheduleDeviationTitle: 'Скачать "Отчёт по отклонениям от планового графика"',
        scheduleDeviationTypesOptions: {
          all: 'Все',
          onlyVacancies: 'Только вакансии',
          onlyStoreShifts: 'Только смены <%shop_singular_R%>',
          outsource: 'Аутсорс',
          notOutsource: 'Не аутсорс'
        },
        scheduleDeviationDisplayByTypes: 'Отображение по типам',
        selectWorkType: 'Выбрать тип работ',
        selectedWorkTypes: 'Выбранные типы работ',
        selectOutsource: 'Выбрать аутсорс сеть',
        selectedOutsourcings: 'Выбранные аутсорс сети',
        selectAll: 'Выбрать все',
        datesInOneMonth: 'Период должен быть в рамках одного месяца',
        tickCheckboxBiometrics: 'Cо снимками биометрии',
        buttonDownloadTitle: 'Скачать',
        incorrectEmail: 'Неправильный адрес элекронной почты',
        buttonEmailTitle: 'Отправить',
        emailWillBeSent: 'Отчёт будет отправлен на указанную электронную почту',
        dateMoreThanError: 'Выберите, пожалуйста, период не более 90 дней',
        // checkboxVersionTitle: 'Версия для инспекции'
        checkboxVersionTitle: 'Версия на подпись',
        selectDaysShorterMonth: 'Выберите, пожалуйста, период не более 31 дня'
      },
      tabledays: {
        copy: 'Ячеек скопировано',
        successCopy: 'Копирование прошло успешно',
        errorCopy: 'Произошла ошибка при копировании',
        continue: 'Вы действительно хотите продолжить?',
        needSelect: 'Необходимо выбрать дни для обмена',
        onlyApprAndNotAppr: 'Допустимы только неподтвержденные или подтвержденные дни',
        invalidDays: 'Выбраны недопустимые дни',
        shiftEcxchange: 'Обмен сменами проведен успешно',
        createdBy: 'Создано',
        editedBy: 'Изменено',
        date: 'Дата',
        comment: 'Комментарий',
        tasks: 'Задачи',
        allowedInterval: 'Допустимый интервал опоздания/раннего ухода',
        noData: 'Нет фактических данных',
        tardinessAndEarlyLeave: 'Опоздание/ранний уход',
        unplannedAttendance: 'Выход вне плана',
        unapprovedChanges: 'Неподтвержденные изменения',
        inconsistencyOfShops: 'Несоответствие <%shop_plural_R%>',
        inconsistencyOfWorkType: 'Несоответствие типа работ',
        inconsistencyOfDayType: 'Несоответствие типа дня',
        additionalShiftMismatch: 'Несоответствие признака рабочего дня (осн/доп)',
        unaccountedOvertime: 'Есть неучтенные переработки',
        noDataInDraft: 'Нет данных в черновике',
        marks: 'Отметки',
        shift: {
          plural_1: 'Смен',
          plural_2: 'Смены'
        },
        warning: 'Предупреждение',
        lock: 'Заблокировано',
        notAvailable: 'Недоступно',
        employmentIs: "\u0422\u0440\u0443\u0434\u043E\u0443\u0441\u0442\u0440\u043E\u0435\u043D \u0432 {shopName}",
        haveNotEmployments: 'Сотрудник не трудоустроен',
        noAnyData: 'Нет данных'
      },
      tableTabel: {
        fact: 'Факт.',
        main: 'Основной',
        additional: 'Доп.',
        details: 'детали',
        dayShiftHours: 'кол-во дневных часов:',
        nightShiftHours: 'кол-во ночных часов:',
        timeOfWork: 'время работа',
        breakTime: 'время перерыва',
        numberOfHours: 'кол-во часов:',
        hour: 'ч',
        minute: 'м',
        workTime: 'время работы:',
        schoolTime: 'время учебы:',
        tripTime: 'время командировки:'
      },
      recalcTimesheetOrWorking: {
        ok: 'Подтвердить',
        timesheetRecalc: 'Пересчет табеля за месяц',
        workingRecalc: 'Пересчет рабочих часов',
        timesheetError: 'При расчете табеля произошла ошибка',
        workingError: 'При расчете рабочих часов произошла ошибка',
        workingErrorDate: 'Дата конца периода не может быть раньше даты начала',
        timesheetSuccess: 'Расчет табеля на месяц успешно завершен',
        workingSuccess: 'Расчет рабочих часов успешно завершен'
      },
      consolidatedReportModal: {
        options: [{
          label: 'Сотрудник + должность',
          value: 'employee_position'
        }, {
          label: 'Должность',
          value: 'position'
        }],
        selectLabel: 'Разрез по'
      }
    },
    exchange: {
      vacancy: 'Вакансия',
      noOneVacancy: 'К сожалению, нет вакансий, соответствующих заданным критериям.',
      inShop: 'в <%shop_singular_P%>',
      replyLabel: 'Назначить',
      approveLabel: 'Подтвердить',
      work: 'работы',
      comes: 'Выходит',
      outsourcingCompany: 'Аутсорс компания',
      refuseTitle: 'Отказ от вакансии',
      reconfirmTitle: 'Переназначить сотрудника',
      deleteModal: {
        question: 'Вы действительно хотите удалить вакансию?',
        answerPositive: 'Вакансия удалена успешно',
        answerNegative: 'Не удалось удалить вакансию'
      },
      confirmModal: {
        question: 'Вы действительно хотите откликнуться на эту вакансию?',
        answerPositive: 'Вы успешно откликнулись на вакансию',
        answerNegative: 'Не удалось откликнуться на вакансию'
      },
      reconfirmModal: {
        question: 'Вы действительно хотите переназначить сотрудника?',
        answerPositive: 'Вы успешно переназначили сотрудника',
        answerNegative: 'Не удалось переназначить сотрудника'
      },
      approveModal: {
        question: 'Вы действительно хотите подтвердить эту вакансию?',
        answerPositive: 'Вы успешно подтвердили вакансию',
        answerNegative: 'Не удалось подтвердить вакансию'
      },
      refuseModal: {
        question: 'Вы действительно хотите отказаться от вакансии?',
        answerPositive: 'Вы успешно отказались от вакансии',
        answerNegative: 'Не удалось отказаться от вакансии'
      }
    },
    settings: {
      name: 'Название',
      title: 'Наименование',
      department: '<%shop_singular_I_Upper%>',
      key: 'Ключ',
      address: 'Адрес',
      city: 'Город',
      parent: 'Подразделение родитель',
      template: 'Шаблон',
      status: 'Статус',
      loadTemplate: 'Шаблон нагрузки',
      settings: 'Шаблон смен',
      timezone: 'Временная зона',
      code: 'Код',
      missing: 'Отсутствует',
      noData: 'нет данных для отображения',
      minShiftLength: 'Минимальная длина смен, ч',
      maxShiftLength: 'Максимальная длина смен, ч',
      permissibleDowntime: 'Допустимая доля простоя',
      maxNumberWorkingHours: 'Максимальное количество рабочих часов подряд',
      minTimeBetweenShifts: 'Минимальное время между сменами, ч',
      depName: 'Название <%shop_singular_R%>',
      forecastStep: 'Шаг прогноза, час.:мин.',
      inputLabelTimezone: 'Часовой пояс',
      area: 'Площадь',
      region: 'Регион',
      workTime: 'Время работы по дням недели',
      workTypes: 'Типы работ',
      minNumberEmpl: 'Мин. кол-во сотрудников',
      maxNumberEmpl: 'Макс. кол-во сотрудников',
      fieldsNotFilledCorrectly: 'Не все поля заполнены правильно',
      failedToSave: 'Не удалось сохранить настройки <%shop_singular_R%>',
      savedSuccessfully: 'Настройки <%shop_singular_R%> успешно сохранены',
      sameWorkingTime: 'одинаковое время работы во все дни',
      depsFilter: 'Фильтр <%shop_plural_R%>',
      positionsFilter: 'Фильтр должностей',
      accessGroupsFilter: 'Фильтр группы доступа',
      businessDriversFilter: 'Фильтр бизнес драйверов',
      operationsFilter: 'Фильтр операций',
      workTypesFilter: 'Фильтр типов работ',
      loadTemplatesFilter: 'Фильтр шаблонов нагрузки',
      timetableTemplatesFilter: 'Фильтр шаблонов расписания',
      tickpointsFilter: 'Фильтр точек отметок',
      staffFilter: 'Фильтр сотрудников',
      enterTheTitle: 'Введите название',
      enterTheCode: 'Введите код',
      enterLastname: 'Введите фамилию',
      enterLogin: 'Введите логин',
      listOfGroups: 'Cписок групп',
      selectDep: 'Выберите <%shop_singular_I%>',
      selectAll: 'Выбрать все',
      selectAllGroups: 'Выберите группы',
      selectedGroupCount: 'Количество выбранных групп',
      selectAllWorkTypes: 'Выберите типы работ',
      selectWorkTypesCount: 'Выбранных типов работ',
      tickpoint: {
        deleteConfirmTitle: 'Подтверждение удаления',
        deleteConfirm: 'Вы действительно хотите удалить эту точку отметки?',
        saveSuccess: 'Точка отметки успешно сохранена',
        deleteSuccess: 'Точка отметки была успешно удалена',
        deleteError: 'Не удалось удалить точку отметки'
      },
      latitude: 'Широта',
      longitude: 'Долгота',
      loadTemplates: {
        addDependency: 'Добавить зависимость',
        addOperation: 'Добавить операцию',
        download: 'Скачать',
        dependency: 'Зависимость',
        formula: 'Формула',
        unknownOperation: 'Неизвестная операция',
        applySuccess: 'Успешно применено',
        applyError: 'Произошла ошибка',
        result: 'Результат'
      },
      accessGroup: 'Группа доступа сотрудника',
      wTypesSavedSuccess: 'Типы работ успешно сохранены',
      wTypesSavedError: 'При сохранении типов работ произошла ошибка'
    },
    staff: {
      currentEmployment: 'Текущие трудоустройства',
      downloadModal: {
        attendanceRecordsTitle: 'Скачать "Отчет по отметкам"',
        reportReworkAndFlawTitle: 'Скачать отчет по переработкам/недоработкам',
        buttonTitle: 'Скачать',
        warning: 'Нужно выбрать хотя бы одного сотрудника'
      },
      photo: 'Фотография',
      fullname: 'ФИО',
      username: 'Логин',
      email: 'Email',
      phoneNumber: 'Телефон',
      position_title: 'Название должности',
      dep_title: '<%shop_singular_I_Upper%>',
      work_types_by_id: 'Вид работы',
      fromWebCam: 'С веб камеры',
      shoot: 'Сделать снимок',
      reShoot: 'Переснять',
      send: 'Отправить'
    },
    coverageCharts: {
      coverageSchedule: 'График покрытия в разрезе типов работ',
      all: 'Все',
      howMuchNeed: 'Сколько нужно',
      howMuchComesOut: 'Сколько выходит'
    },
    forecast: {
      businessDrivers: 'Бизнес драйверы',
      operations: 'Операции',
      workTypes: 'Типы работ',
      additionalFeatures: 'Дополнительные признаки',
      uploadWorkloadModal: {
        workloadTitle: 'Загрузка нагрузки',
        uploadSuccess: 'Данные загружены успешно',
        downloadTemplate: 'Скачать шаблон',
        downloadDescription: 'Скачать описание',
        fileLargeError: 'Данный файл слишком большой',
        uploadErrorWrongData: 'Неверные данные в загруженном файле',
        uploadErrorsWarning: 'Ошибки при загрузке',
        selectPlanDays: 'План',
        downloadExampleFileTitle: 'Скачать шаблон',
        selectFactDays: 'Факт'
      }
    }
  },
  modals: {
    departments: {
      title: 'Выбор <%shop_singular_R%>',
      okButton: 'Выбрать',
      filterPlaceholder: 'Поиск по названию',
      depsLengthError: 'Необходимо выбрать как минимум один <%shop_singular_I%>',
      toggleButton: 'С выбором дочерних'
    },
    staffFilter: {
      filterTable: 'Фильтр таблицы',
      selectedEmployees: 'Выбрано сотрудников',
      selectedWorkTypes: 'Выбрано типов работ',
      selectedWorkerTypes: 'Выбрано типов сотрудников',
      selectEmployees: 'Выбрать сотрудников',
      selectWorkTypes: 'Выбрать тип работ',
      selectWorkerTypes: 'Выбрать тип сотрудника',
      selectAll: 'Выбрать все',
      selectAllUsers: 'Выбрать всеx',
      workerTypeOptions: [{
        label: 'Сотрудник магазина',
        value: EMPLOYEE_EMPLOYMENT_STATUSES
      }, {
        label: 'Внутренняя биржа',
        value: INTERNAL_EMPLOYMENT_STATUSES
      }, {
        label: 'Аутсорс',
        value: OUTSOURCE_EMPLOYMENT_STATUSES
      }]
    },
    staffAdd: {
      title: 'Добавление сотрудников',
      fullname: 'ФИО',
      addBtnLabel: 'Добавить',
      dateHired: 'Дата приёма',
      email: 'Email',
      phoneNumber: 'Телефон',
      addWorker: '+ добавить работника',
      addWorkerSuccess: 'Сотрудник добавлен успешно',
      saveEmploymentsSuccess: 'Трудоустройства сотрудников сохранены успешно'
    },
    workerDetails: {
      menu: [{
        label: 'Общая информация',
        icon: 'info',
        link: 'Info'
      }, {
        label: 'Трудоустройства',
        icon: 'device_hub',
        link: 'Employments'
      }, {
        label: 'График смен',
        icon: 'today',
        link: 'ShiftSchedule',
        options: {
          show_employee_shift_schedule_tab: true
        }
      }, {
        label: 'Безопасность',
        icon: 'security',
        link: 'Security'
      }, {
        label: 'Медицинские документы',
        icon: 'medical_services',
        link: 'Medical'
      }]
    },
    departmentSettings: {
      createTitle: 'Создание <%shop_singular_R%>',
      editTitle: 'Параметры <%shop_singular_R%>',
      commonSettings: 'Общие параметры',
      schedule: 'График работы',
      cellSavedSuccess: 'График работы успешно сохранен',
      cellSavedError: 'Не удалось сохранить график работы',
      autoscheduling: 'Автосоставление',
      calculationOfTheNeed: 'Расчет потребности',
      ipAddresses: 'IP адреса',
      confirmIpDelete: 'Вы действительно хотите удалить IP адрес?',
      newIpAddress: 'Новый IP адрес',
      invalidIpAddress: 'Неверный формат IP адреса'
    },
    operation: {
      constValue: 'Постоянное значение',
      newOperation: 'Новая операция',
      operation: '* операция',
      timeDuration: 'Время выполнения',
      forecastStep: '* шаг прогноза',
      depends: 'Зависит от',
      noDepends: 'Не имеет зависимостей',
      add: 'Добавить',
      formula: 'Формула',
      subNewOperation: '* новая операция',
      deleteConfirmTitle: 'Подтверждение удаления',
      operationDeleteConfirm: 'Вы действительно хотите удалить эту операцию?',
      operationSaveSuccess: 'Операция успешно сохранена',
      operationDeleteSuccess: 'Операция была успешно удалена',
      operationDeleteError: 'Не удалось удалить операцию',
      dependenceDeleteSuccess: 'Зависимость была успешно удалена',
      validError: 'Не все поля заполнены верно',
      operationLabel: 'Операция',
      dtFromLabel: 'Время начала',
      dtToLabel: 'Время завершения',
      forecastStepLabel: 'Шаг прогноза',
      constValueLabel: 'Постоянное значение',
      min_30: '30 минут',
      hour_1: '1 час',
      day_1: '1 день'
    },
    deleteSchedule: {
      modalTitle: 'Удаление графика',
      selectAll: 'Выбрать всех',
      deletePeriod: 'Период для удаления',
      selectPlanDays: 'План',
      selectFactDays: 'Факт',
      daysWithinNotFound: 'Не найдено подходящих дней',
      selectWorkers: 'Выберите сотрудников',
      selectDates: 'Выберите даты',
      deletedSuccess: 'Удаление успешно произведено',
      excludeCreatedBy: 'Не удалять ручные изменения',
      excludeCreatedByOtherDepartment: 'Не удалять рабочие дни в других отделах',
      searchWorkers: 'Поиск'
    },
    duplicateSchedule: {
      modalTitle: 'Копирование графика',
      modalCopyMonthTitle: 'Копирование из месяца в месяц',
      selectAll: 'Выбрать всех',
      copyPeriod: 'Период для копирования',
      copyPeriodMonth: 'Скопировать из периода',
      pastePeriodMonth: 'Вставить в период',
      typeDay: 'Типы дней',
      selectPlanDays: 'План',
      selectFactDays: 'Факт',
      selectWorkers: 'Выберите сотрудников',
      selectDates: 'Выберите даты',
      selectWorkersDay: 'Выберите тип дня',
      copiedSuccess: 'Копирование успешно произведено',
      fromPlanToPlanDraft: 'Из плана в план черновик',
      fromFactToFactDraft: 'Из факта в факт черновик',
      fromPlanToFactDraft: 'Из плана в факт черновик',
      searchWorkers: 'Поиск'
    },
    settings: {
      code: 'код',
      name: 'название',
      title: 'наименование',
      availabilityToCreateOutsourcingJobs: 'Доступность для создания аутсорс вакансии',
      dep: '<%shop_singular_I%>',
      key: 'ключ',
      operationName: 'имя типа операции',
      availableFunctions: 'Доступные функции',
      positionName: 'наименование должности',
      createPosition: 'Создание должности',
      updatePosition: 'Изменение должности',
      createTickpoint: 'Создание точки отметок',
      updateTickpoint: 'Изменение точки отметок',
      createAccessGroup: 'Создание группы пользователей',
      updateAccessGroup: 'Изменение группы пользователей',
      createLoadTemplate: 'Создание шаблона нагрузки',
      updateLoadTemplate: 'Изменение шаблона нагрузки',
      createTimetableTemplate: 'Создание шаблона расписания',
      updateTimetableTemplate: 'Изменение шаблона расписания',
      createBlockWorkDays: 'Ограничение на редактирование смен',
      exit1day: 'Допустим еженедельный перерыв в 1 выходной день',
      exit42hours: '42 часа недельный перерыв',
      pairedWeekday: 'Обязательные спаренные выходные',
      businessDriver: 'бизнес-драйвера',
      operation: 'операции',
      workType: 'типа работ',
      create: 'Создание',
      update: 'Изменение',
      toCreate: 'Создать',
      toSave: 'Сохранить',
      feedbackTitle: 'Обратная связь',
      searchShop: 'Поиск магазина',
      toggleButton: 'С выбором дочерних',
      block: 'Снятие запрета',
      successMessage: 'Изменения успешно применены'
    },
    employment: {
      title: 'Трудоустройства',
      add: 'Добавить',
      department: '<%shop_singular_I_Upper%>',
      position: 'Должность',
      tabelCode: 'Табельный номер',
      salary: 'Зарплата',
      startDate: 'Дата начала работы',
      endDate: 'Дата конца работы',
      shareOfWorkingHours: 'Доля рабочих часов',
      sawhSettings: 'Настройка нормы часов',
      fixedSchedule: 'фиксированный график',
      displayGraph: 'Отображать в графике',
      displayGraphInOtherShops: 'Отображать в графике других магазинов',
      workType: 'Типы работ',
      availabilityType: 'Тип доступности сотрудника',
      not: 'нет',
      main: 'осн',
      additional: 'доп',
      weekly: 'Недельный',
      floating: 'Скользящий',
      periodDays: 'Дней в периоде',
      startOfPeriodicity: 'Начало периодичности',
      dayEditMode: 'Режим редактирования дня',
      limitations: 'Ограничения',
      wishes: 'Пожелания',
      archive: 'Архив',
      newEmployment: 'Новое трудоустройство',
      noStartEndTimes: 'Не проставлены часы работы <%shop_singular_R%>',
      group: 'Группа доступа сотрудника',
      noWorkTypes: 'Отсутствуют доступные типы работ',
      unknownDepartment: 'Неизвестный отдел',
      unknownPosition: 'Неизвестная должность',
      unknownGroup: 'Неизвестная группа',
      historyEmployments: 'Прошлые',
      futureEmployments: 'Будущие',
      allEmployments: 'Все'
    },
    reports: {
      title: 'Фильтр графиков',
      selectAll: 'Выбрать всё',
      selectAllEmployees: 'Выбрать всех',
      selectEmployees: 'Выбрать сотрудников',
      selectedEmployees: 'Выбрано сотрудников',
      displayByTypes: 'Отображение по типам',
      all: 'Все',
      onlyVacancies: 'Только вакансии',
      onlyStoreShifts: 'Только смены <%shop_singular_R%>',
      outsource: 'Аутсорс',
      notOutsource: 'Не аутсорс',
      selectWorkType: 'Выбрать тип работ',
      selectedWorkTypes: 'Выбранные типы работ',
      selectOutsource: 'Выбрать аутсорс сеть',
      selectedOutsourcings: 'Выбранные аутсорс сети',
      modalPivotTabelTitle: 'Скачать сводный табель',
      download: 'Скачать'
    },
    tickpoint: {
      deleteConfirmTitle: 'Подтверждение удаления',
      deleteConfirm: 'Вы действительно хотите удалить эту точку отметки?',
      saveSuccess: 'Точка отметки успешно сохранена',
      deleteSuccess: 'Точка отметки была успешно удалена',
      deleteError: 'Не удалось удалить точку отметки'
    },
    exchange: {
      title: 'Выбор аутсорс сети',
      okButton: 'Выбрать',
      filterPlaceholder: 'Поиск по названию',
      depsLengthError: 'Необходимо выбрать как минимум одну сеть',
      toggleButton: 'С выбором дочерних'
    },
    autoschedulingSettings: {
      title: 'Настройки автосоставления',
      shiftpattern: 'шаблон смен',
      compilationRules: 'Правила составления',
      invalidStartTime: 'Недопустимое время начала смены',
      invalidEndTime: 'Недопустимое время окончания смены',
      savedSuccess: 'Настройки автосоставления успешно сохранены',
      savedError: 'При сохранении настроек произошла ошибка'
    },
    calculationOfTheNeed: {
      loadTemplates: 'шаблон нагрузки',
      savedSuccess: 'Изменения успешно сохранены',
      savedError: 'При сохранении произошла ошибка'
    },
    shiftSchedule: {
      title: 'График смен',
      total: 'Всего:'
    },
    medical: {
      title: 'Медицинские документы',
      addBtnTitle: 'Добавить документ',
      selectDocumentTitle: 'Тип документа',
      dateFromTitle: 'Актуален от (дата)',
      dateToTitle: 'Актуален до (дата)',
      successSave: 'Медицинские документы сохранены',
      errorSave: 'Ошибка сохранения медицинских документов'
    }
  },
  dateTimeSettings: {
    dateMask: 'DD.MM.YYYY',
    timeMask: 'HH:mm',
    dayMonthDateMask: 'DD.MM',
    daysOfWeek: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    firstDayOfWeek: '1',
    hoursSettings: ['час', 'часа', 'часов']
  },
  table: {
    selectedRows: 'Строк выбрано',
    visibleFields: 'Отображаемые поля',
    selectAll: 'Выбрать всё',
    deselectAll: 'Снять выбор всех',
    enterValue: 'Введите',
    templateOperation: {
      operation: 'Операция',
      startTime: 'Время начала',
      endTime: 'Время завершения',
      forecastStep: 'Шаг прогноза',
      constValue: 'Постоянное значения'
    },
    relations: {
      dependsOn: 'Зависит от',
      formula: 'Формула'
    }
  },
  tabelTypes: {
    'F': 'Фактический табель',
    'M': 'Основной табель',
    'A': 'Дополнительный  табель',
    'MA': 'Осн/доп табель'
  },
  errors: {
    status: {
      500: 'Пожалуйста, обратитесь в техническую поддержку.',
      502: 'Сервис временно недоступен. Пожалуйста, попробуйте позже.',
      504: 'Превышено время ожидания ответа сервера. Пожалуйста, попробуйте позже.'
    }
  }
};